import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const privacylist1 = t("privacylist1", { returnObjects: true });
  const privacylist2 = t("privacylist2", { returnObjects: true });
  const privacylist3 = t("privacylist3", { returnObjects: true });
  const privacylist4 = t("privacylist4", { returnObjects: true });
  const privacylist5 = t("privacylist5", { returnObjects: true });
  const privacylist6 = t("privacylist6", { returnObjects: true });
  const privacylist7 = t("privacylist7", { returnObjects: true });
  const privacylist8 = t("privacylist8", { returnObjects: true });
  const privacylist9 = t("privacylist9", { returnObjects: true });
  const privacylist10 = t("privacylist10", { returnObjects: true });
  const privacylist11 = t("privacylist11", { returnObjects: true });
  const privacylist12 = t("privacylist12", { returnObjects: true });
  const privacylist13 = t("privacylist13", { returnObjects: true });
  const privacylist14 = t("privacylist14", { returnObjects: true });
  const privacylist15 = t("privacylist15", { returnObjects: true });
  const privacylist16 = t("privacylist16", { returnObjects: true });
  const privacylist17 = t("privacylist17", { returnObjects: true });
  const privacylist18 = t("privacylist18", { returnObjects: true });
  const privacylist19 = t("privacylist19", { returnObjects: true });
  const privacylist20 = t("privacylist20", { returnObjects: true });
  const privacylist21 = t("privacylist21", { returnObjects: true });

  return (
    <section className="backdrop-blur-2xl flex justify-start items-start flex-col  p-6">
      <h1 className="text-3xl max-md:text-xl font-bold text-white text-center uppercase">
        {t("privacy")}
      </h1>

      <div className="p-6 max-w-6xl flex justify-start items-start text-white flex-col gap-6">
        <p>{t("privacytitle")}</p>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist1.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist2.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist3.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist4.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist5.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist6.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist7.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist8.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist9.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist10.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist11.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist12.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist13.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist14.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist15.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist16.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist17.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist18.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist19.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist20.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
        <ul className="flex flex-col pb-3 text-white">
          {privacylist21.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>

        <div>
          <h1 className="text-white">{t("dateof")}</h1>
          <h1 className="text-white">{t("director")}</h1>
        </div>
      </div>
    </section>
  );
};
export default PrivacyPolicy;
